package com.example.readingnotes.presentation.stripeconnect

import com.example.readingnotes.domain.model.StripeConnectStatus

/**
 * UI state for Stripe Connect onboarding screen
 */
data class StripeConnectState(
    val isLoading: Boolean = false,
    val accountStatus: StripeConnectStatus? = null,
    val isGeneratingOnboardingLink: Boolean = false,
    val isRefreshing: Boolean = false,
    val onboardingUrl: String? = null,
    val errorMessage: String? = null,
)
